import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions/index";
import { FormContext } from "../../pages/_app";
import dynamic from "next/dynamic";

const FullPageLoader = dynamic(() =>
	import("../FullPageLoader/FullPageLoader")
);
import Industry from "../industry/industry";
import IndustryNew from "../industry-new/industry";
import HocHead from "../HigherOrderComponent/HocHead";
const TalkToExperts = dynamic(() => import("../modals/TalkToExperts"), { ssr: false });

const IndustryPage = (props) => {
	const slug = props.slug;
	const loading = useSelector((state) => state.loaderReducer.loading);
	const dispatch = useDispatch();

	const [industryData, setIndustryData] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const industriesFormContext = {
		showModal,
		showForm: () => setShowModal(true),
		hideForm: () => setShowModal(false),
	};

	const sdata = props.data;
	const data = sdata.data[0].attributes;
	const seo = sdata.data[0].attributes.seo;
	const blocks = sdata.data[0].attributes.blocks;

	useEffect(() => {
		let industries = [];
		industries = blocks
			.find((block) => block.__component === "blocks.our-spectrums")
			?.Industry_Spectrum?.map((data) => data.title);

		setIndustryData(industries);
	}, [blocks]);

	useEffect(() => {
		dispatch(actions.hideLoader());
	}, []);

	function SwitchCase(props) {
		switch (props.title) {
			case "main-v2":
				return (
					<IndustryNew
						blocks={blocks}
						slug={props.title}
						type="Industry"
					/>
				);
			default:
				return (
					<Industry
						blocks={blocks}
						slug={props.title}
						type="Industry"
					/>
				);
		}
	}

	return (
		<>
			{seo && <HocHead seo={seo} />}

			{loading && <FullPageLoader />}

			<FormContext.Provider value={industriesFormContext}>
				<SwitchCase title={data.template} />
			</FormContext.Provider>

			<TalkToExperts
				show={showModal}
				hide={() => setShowModal(false)}
				industry={props.title}
				industry_data={industryData}
			/>

			{/* { loading ? <FullPageLoader /> : <SwitchCase title={data.title}></SwitchCase> } */}
		</>
	);
};

export default IndustryPage;
